import { dispatchAnalyticsTrack } from "~/lib/segment";

import type { RuleInput } from "./modal/types";

import type { AutoRecordRuleLevel } from "~/__generated__/CreateAndEditModalRule.graphql";

function dispatchUserAutoRecordRuleAnalytics(rule: Partial<RuleInput>, eventName: string) {
	dispatchAnalyticsTrack(`[User Copilot Settings] ${eventName}`, rule);
}

function dispatchWorkspaceAutoRecordRuleAnalytics(rule: Partial<RuleInput>, eventName: string) {
	dispatchAnalyticsTrack(`[Workspace Copilot Settings] ${eventName}`, rule);
}

export function dispatchAutoRecordRuleAnalytics(
	rule: Partial<RuleInput> & { ruleLevel: AutoRecordRuleLevel },
	eventName: string,
) {
	if (rule.ruleLevel === "USER") {
		dispatchUserAutoRecordRuleAnalytics(rule, eventName);
	} else {
		dispatchWorkspaceAutoRecordRuleAnalytics(rule, eventName);
	}
}
